<template>
  <div class="share-app" :style="height ? `height: ${height}px` : ''">
    <VideoItem
      ref="videoRef"
      :src="data.videoInfo.url"
      v-model:showPause="showPause"
      object-position="top"
      :poster="data.videoInfo.coverPicUrl || data.videoInfo.firstFramePicUrl"
      @timeupdate="ontimeupdate"
    >
      <div class="video-header">
        <i class="header-logo"></i>
        <span class="header-text"></span>
        <div class="header-btn" @click="gotoKy()">探索更多</div>
      </div>
      <div class="video-footer">
        <div class="video-info">
          <div class="cover-ct">
            <p class="cover-author-name">
              @{{ data.videoItem.author.nickName }}{{ showPause }}
            </p>
            <p class="cover-content">{{ data.videoItem.content }}</p>
          </div>
          <div class="cover-op">
            <div
              class="op-item author-item"
              :style="`background-image: url('${data.videoItem.author.iconUrl}')`"
              @click="gotoKy()"
            ></div>

            <div class="op-item" @click="gotoKy()">
              <i
                :class="[
                  'op-icon',
                  'icon-like',
                  data.videoItem.isLike ? 'active' : '',
                ]"
              ></i>
              <p class="op-text">{{ data.videoItem.likeCount }}</p>
            </div>

            <div class="op-item" @click="gotoKy()">
              <i class="op-icon icon-share"></i>
              <p class="op-text">{{ data.videoItem.shareCount || '' }}</p>
            </div>
          </div>
        </div>
        <div :class="['footer-progress', showPause ? 'show-pause' : '']">
          <span class="time">{{ currentTime }}</span>
          <ClientOnly
            ><vue-slider
              v-model="percentage"
              class="video-progress"
              pivot-text=""
              inactive-color="rgba(255, 255, 255, 0.3)"
              active-color="#f7365d"
              :min="0"
              :max="100"
              tooltip="none"
              @change="onSeek"
              @drag-start="dragged = true"
              @drag-end="dragged = false"
            >
            </vue-slider
          ></ClientOnly>

          <span class="time">{{ duration }}</span>
          <!-- <div v-show="showBuffer" class="video-buffer">
            <div class="buffer-bar"></div>
          </div> -->
        </div>
        <div class="goto-ky-btn" @click="gotoKy()">打开快影制作同款</div>
      </div>
    </VideoItem>
  </div>
</template>

<script setup>
import VideoItem from '@/components/ky/video-item'
import crypto from '@/utils/crypto'
import 'vue-slider-component/dist-css/vue-slider-component.css'
import 'vue-slider-component/theme/default.css'
useHead({
  script: [{ src: '/js/flexible.js', type: 'text/javascript' }],
})
const { data } = await useAsyncData(async (params) => {
  const route = useRoute()
  const config = useRuntimeConfig()
  const host = config.public.VITE_KY_API_HOST
  const { video } = await $fetch(
    `${host}/rest/n/kmovie/app/community/popularShareH5?postId=${
      route.query.photoId
    }&${crypto(true)}`
  )
  return {
    videoInfo: video.videos[0].videoInfo,
    videoItem: video,
    query: route.query,
    logData: {
      postid: video.postId,
      author_id: video.author.userIdStr,
      from: route.query.from,
    },
  }
})
const showPause = ref(true)
const currentTime = ref('00:00')
const dragged = ref(false)
const percentage = ref(0)
const videoRef = ref(null)
const { appContext } = getCurrentInstance()
const height = ref(0)
const duration = computed(() => {
  return formateTime(
    data.value.videoInfo?.duration
      ? (data.value.videoInfo.duration / 1000) | 0
      : 0
  )
})
onMounted(() => {
  webLog('SHOW', 'KY_share_video_h5page')
  if (window?.screen?.availHeight) {
    height.value = window.screen.availHeight + 'px'
  }
})

watch(showPause, (val) => {
  if (!val) {
    webLog('CLICK', 'KY_share_video_play_h5')
  }
})
function formateTime(s) {
  const padstart = function (num) {
    return String(num).padStart(2, '0')
  }
  const min = (s / 60) | 0
  return `${padstart(min)}:${padstart(s % 60)}`
}
function ontimeupdate() {
  const _currentTime = videoRef.value.$refs.player.currentTime
  const duration = videoRef.value.$refs.player.duration
  if (showPause.value) {
    currentTime.value = formateTime(_currentTime | 0)
  }
  if (!dragged.value) {
    percentage.value = ((_currentTime / duration) * 100) | 0
  }
}
function onSeek(val) {
  videoRef.value.$refs.player.currentTime =
    (videoRef.value.$refs.player.duration * val) / 100
}
function getDid(name = 'did') {
  const arr = document.cookie.match(
    new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  )
  if (arr != null) return decodeURIComponent(arr[2])
  return ''
}
function webLog(eventType, eventFlag) {
  const device_id = getDid() || getDid('_did')
  const logData = data.value.logData
  console.log(eventType, eventFlag, {
    ...logData,
    device_id,
  })
  appContext.config.globalProperties.$log.collect(eventType, eventFlag, {
    ...logData,
    device_id,
  })
}
function gotoKy() {
  const url = `kwaiying://krn?tab=2&tabName=popular&bundleId=KyCourse&componentName=detail&data=${encodeURIComponent(
    JSON.stringify({
      getStorage: 0,
      isSingle: 1,
      extra: {
        postId: data.value.query.photoId,
      },
      from: 'share',
    })
  )}`
  appContext.config.globalProperties.$openApp(url)
  webLog('CLICK', 'KY_share_video_h5_donwload_click')
}
</script>
<style lang="less">
@padding: 0.34rem;
.share-app {
  width: 100vw;
  height: 100vh;
  background-color: #191919;
}
.video-header {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0 @padding;
  height: 0.92rem;
  line-height: 0.92rem;
  background: rgba(0, 0, 0, 0.4);
  font-size: 0.28rem;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.header-logo {
  width: 4.16rem;
  height: 0.55rem;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('../../assets/img/ky-logo.png');
}
.header-btn {
  pointer-events: auto;
  width: 1.28rem;
  height: 0.56rem;
  line-height: 0.56rem;
  background-color: #f7365d;
  border-radius: 0.08rem;
  text-align: center;
  font-weight: bold;
  font-size: 0.24rem;
}
.header-text {
  width: 1px;
  flex: 1;
  text-align: left;
}
.video-info {
  display: flex;
  align-items: flex-end;
  color: rgb(230, 230, 230);
  font-size: 0.28rem;
  line-height: 0.41rem;
  padding-top: 1.96rem;
  font-weight: bold;
  box-sizing: border-box;
}
.video-footer {
  position: absolute;
  display: flex;
  flex-direction: column;
  padding: 0 @padding;
  box-sizing: border-box;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 3;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 100%
  );
}
.cover-author-name {
  font-size: 0.3rem;
  line-height: 0.45rem;
  margin-bottom: 0.12rem;
}
.cover-op {
  width: 0.9rem;
  margin-left: 0.93rem;
}
.op-item {
  pointer-events: auto;
  width: 0.84rem;
  height: 0.84rem;
  margin: 0 auto;
  margin-top: 0.34rem;
}
.author-item {
  margin-top: 0;
  width: 0.9rem;
  height: 0.9rem;
  margin-bottom: 0.54rem;
  border: 0.03rem solid #fff;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
}
.cover-content {
  font-size: 0.26rem;
  max-height: 1.23rem;
  line-height: 0.41rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.cover-ct {
  flex: 1;
}
.op-text {
  color: #fff;
  text-align: center;
}
.op-icon {
  display: block;
  width: 0.84rem;
  height: 0.84rem;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.icon-like {
  background-image: url('../../assets/img/like.png');
  &.active {
    background-image: url('../../assets/img/like_active.png');
  }
}
.icon-share {
  background-image: url('../../assets/img/share.png');
}
.goto-ky-btn {
  @size: 0.84rem;

  height: @size;
  font-size: 0.3rem;
  text-align: center;
  color: #fff;
  line-height: @size;
  background-color: #f7365d;
  border-radius: 0.08rem;
  margin-bottom: 0.7rem;
  margin-top: 0.4rem;
  font-weight: bold;
  pointer-events: auto;
}
.footer-progress {
  pointer-events: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 0.2rem;
  margin-top: 0.53rem;
  color: #fff;
  .time {
    display: none;
  }
  &.show-pause .time {
    display: initial;
    line-height: 1;
  }

  .vue-slider-dot {
    display: none;
    background: #fff;
  }
  &.show-pause .vue-slider-dot {
    display: inline-block;
    width: 0.22rem !important;
    height: 0.22rem !important;
    border-radius: 50%;
  }
  /*! purgecss start ignore */
  .video-progress {
    width: 1px;
    flex: 1;
    margin: 0 0;
    height: 0.04rem !important;
    padding: 0.16rem 0;
    .vue-slider-rail {
      background-color: rgba(255, 255, 255, 0.3);
    }
    .vue-slider-process {
      background-color: #fff;
    }
  }
  .vue-slider-dot-handle {
    box-shadow: none;
  }
  &.show-pause .video-progress {
    margin: 0 0.2rem;
  }
}
</style>
